/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Ai_PolishInputs */

const cs_blog_ai_polish = /** @type {(inputs: Blog_Ai_PolishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vylepšit tento jazyk`)
};

const en_blog_ai_polish = /** @type {(inputs: Blog_Ai_PolishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polish this language`)
};

/**
* | output |
* | --- |
* | "Polish this language" |
*
* @param {Blog_Ai_PolishInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_ai_polish = /** @type {((inputs?: Blog_Ai_PolishInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Ai_PolishInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_ai_polish(inputs)
	return cs_blog_ai_polish(inputs)
});